var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockHeading2React(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.74951 5h-5v-5h-3.74999828v15h3.74999828v-6.25h5v6.25h3.74999v-15h-3.74999z",
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.1705105 17.84656h6.6988v-1.892h-3.4091v-.0511l.8182-.6819c1.9901-1.6576 2.4972-2.51843 2.4972-3.52837 0-1.62785-1.3338-2.69319-3.4262-2.69319-2.0326 0-3.3537 1.12927-3.3494105 2.96591h2.2500105c-.0043-.73295.4432-1.14204 1.0994-1.14204.652 0 1.1165.40483 1.1165 1.07386 0 .6179-.3963 1.01843-1.0398 1.55113l-3.2556 2.6932z"
  }))));
}
export default SvgBlockHeading2React;